import React from 'react';

import { Container } from './styles';

function LabelPremium() {
  return <Container>PREMIUM</Container>;
}

export default LabelPremium;
